<!--  -->
<template>
  <div>
    <div style="display: flex;align-items: center;margin-bottom:30px">
      <div style="color:#a9a297;font-size: 15px;">落地页名称：</div>
      <el-input
        v-model="landingpagename"
        style="width:300px"
        placeholder="请输入落地页名称"
      />
    </div>
    <div class="edit_box">
      <div class="siopw_box">
        <h2 style="margin-bottom: 10px;">新增组件</h2>
        <div class="wjaeeaw">
          <div class="wjaeeawr">
            <div class="imwa_vir">
              <div
                class="imwa_vix"
                @click="addImageDiv"
              >
                <img
                  src="https://xj.gtimg.cn/qzone/biz/gdt/promotion/pages/landingpage/pagemakerlite/cb41a4e56e295a55ae09.svg"
                  alt=""
                >
              </div>
              <div style="margin-top: 10px;margin-left: 32px;">图片</div>
            </div>

            <div class="imwa_vir">
              <div
                class="imwa_vix"
                @click="addNormalButton"
              >
                <img
                  src="https://xj.gtimg.cn/qzone/biz/gdt/promotion/pages/landingpage/pagemakerlite/632dd350e09d36503fb0.svg"
                  alt=""
                >
              </div>
              <div style="margin-top: 10px;margin-left: 32px;">按钮</div>
            </div>
          </div>
          <div class="wjaeeawr">
            <div class="imwa_vir">
              <div
                class="imwa_vix"
                @click="addParagraphText"
              >
                <img
                  src="https://xj.gtimg.cn/qzone/biz/gdt/promotion/pages/landingpage/pagemakerlite/4d21a0127d4bfaff26da.svg"
                  alt=""
                >
              </div>
              <div style="margin-top: 10px;margin-left: 32px;">文本</div>
            </div>

            <!-- <div class="imwa_vir">
              <div
                class="imwa_vix"
                @click="addFloatingButton"
              >
                <img
                  src="	https://xj.gtimg.cn/qzone/biz/gdt/promotion/pages/landingpage/pagemakerlite/9bdc73b0c63c059c5682.svg"
                  alt=""
                >
              </div>
              <div style="margin-top: 10px;margin-left: 20px;">悬浮按钮</div>
            </div> -->
          </div>
        </div>

      </div>
      <div class="wjaeeawawe">
        <!-- 调色板 -->
        <div class="wjkwew">
          <input
            v-model="backrColor"
            type="color"
          >
          <div style="margin-top: 3px;">背景</div>
        </div>

        <div
          class="edit-area"
          :style="{ backgroundColor: backrColor }"
          @click.self="clearSelection"
        >
          <div
            v-if="elements.length == 0"
            class="left_boxoweduwe"
          >
            请选择左侧组件
          </div>
          <div
            v-for="(items, index) in elements"
            v-else
            :key="index"
            class="editable-block"
            :class="{ selected: currentEditIndex === index }"
            @click.stop="selectElement(index)"
            v-html="items.html"
          />
        </div>
      </div>
      <div
        v-if="currentEditIndex == null"
        class="left_boxowe"
      >
        请新建或选择所要编辑的内容
      </div>
      <div
        v-else
        class="left_box"
      >
        <!-- 颜色选择器 -->
        <div
          v-if="elements[currentEditIndex].type == 'text'"
          class="control-panel"
        >
          <div>
            <div style="margin-bottom: 10px;font-weight: 500;font-size: 18px;">文案</div>
            <!-- <textarea
              v-model="textContent"
              rows="3"
              cols="40"
              @input="applyTextStyle"
            /> -->
            <el-input
              v-model="textContent"
              type="textarea"
              rows="3"
              cols="40"
              placeholder="请输入内容"
              maxlength="10000"
              show-word-limit
              @input="applyTextStyle"
            />
            <div style="margin:10px 0px;font-weight: 500;font-size: 18px;">样式</div>
            <div
              class="wjaeeaw"
              style="margin-bottom: 10px;"
            >
              <label>字体颜色：</label>
              <input
                v-model="fontColor"
                type="color"
                @input="applyTextStyle"
              >
            </div>
            <div
              class="wjaeeaw"
              style="margin-bottom: 10px;"
            >
              <label>字号：</label>
              <!-- <input
                type="number"
                v-model="fontSize"
                style="width: 60px;"
                @input="applyTextStyle"
              /> PX -->
              <el-input-number
                v-model="fontSize"
                :min="15"
                :max="100"
                label="字号"
                @input="applyTextStyle"
              />
            </div>
            <div class="wjaeeaw">
              <label>对齐方式：</label>
              <div class="wjaeeaw">
                <div
                  :class="['align-button', currentAlign === 'left' ? 'active' : '']"
                  @click="changeAlign('left')"
                >
                  默认
                </div>
                <div
                  :class="['align-button', currentAlign === 'center' ? 'active' : '']"
                  @click="changeAlign('center')"
                >
                  居中
                </div>
              </div>
            </div>

            <!-- <button @click="applyTextStyle">应用</button> -->
            <!-- <button
              @click="moveUp"
              :disabled="currentEditIndex === 0"
            >⬆️ 向上</button>
            <button
              @click="moveDown"
              :disabled="currentEditIndex === elements.length - 1"
            >⬇️ 向下</button>
            <button @click="deltert">删除</button> -->
          </div>
        </div>

        <!-- 图片替换 -->
        <div v-if="elements[currentEditIndex].type == 'image'">
          <div>
            <label>图片素材：</label>
            <div>
              <img
                v-if="imageUrl!=''"
                :src="imageUrl"
                style="width: 80px;height: 80px;margin: 10px 0px;"
                alt=""
              >
              <el-upload
                ref="upload"
                class="upload-demo"
                action="#"
                :http-request="httpRequest"
                :multiple="true"
                :show-file-list="false"
                :limit="100"
              >
                <el-button
                  size="small"
                  type="primary"
                  plain
                >上传图片</el-button>
              </el-upload>
            </div>

          </div>

          <!-- <button @click="applyImage">替换</button> -->
        </div>

        <!-- 按钮样式设置 -->
        <div v-if="elements[currentEditIndex].type == 'button' || elements[currentEditIndex].type == 'xuanbutton'">
          <div style="margin-bottom: 10px;">
            <div style="margin-bottom: 10px;">按钮文字：</div>
            <!-- <input
              v-model="editLabel"
              @input="applyButtonStyle"
            /> -->
            <el-input
              v-model="editLabel"
              type="textarea"
              rows="3"
              cols="40"
              placeholder="请输入内容"
              maxlength="10000"
              show-word-limit
              @input="applyButtonStyle"
            />
          </div>
          <div style="margin-bottom: 10px;">
            <label>背景颜色：</label>
            <input
              v-model="editBackground"
              type="color"
              @input="applyButtonStyle"
            >
          </div>
          <div style="margin-bottom: 10px;">
            <label>字体颜色：</label>
            <input
              v-model="editColor"
              type="color"
              @input="applyButtonStyle"
            >
          </div>
          <div style="margin-bottom: 10px;">
            <label>字号：</label>
            <!-- <input
              type="number"
              v-model="editFontSize"
              @input="applyButtonStyle"
            />PX -->
            <el-input-number
              v-model="editFontSize"
              :min="15"
              :max="100"
              label="字号"
              @input="applyButtonStyle"
            />
          </div>

          <!-- <button @click="applyButtonStyle">应用按钮样式</button> -->
        </div>
        <div style="margin-top:10px">
          <!-- <el-button
            type="primary"
            size="mini"
            :disabled="currentEditIndex == 0"
            @click="moveUp"
          >向上</el-button>
          <el-button
            type="primary"
            size="mini"
            :disabled="currentEditIndex == elements.length - 1"
            @click="moveDown"
          >向下</el-button> -->
          <el-button
            type="danger"
            size="mini"
            @click="deltert"
          >删除</el-button>
          <div style="display: flex;align-items: center;">
            <div>获客链接：</div>
            <el-input
              v-model="Passerbyvalue"
              style="width:300px"
              placeholder="请输入内容"
            />
          </div>

        </div>
        <!-- <div>
          <button @click="addNormalButton">➕ 添加普通按钮</button>
          <button @click="addFloatingButton">➕ 添加悬浮按钮</button>
          <button @click="addParagraphText">➕ 新增纯文本</button>
          <button @click="addImageDiv">🖼️ 新增图片</button>
        </div> -->
      </div>

    </div>
    <el-button
      type="primary"
      @click="sumbiter"
    >确定</el-button>
    <!-- <el-form
      :label-position="labelPosition"
      label-width="100px"
    >
      <el-form-item label="appid">
        <el-input
          v-model="app_id"
          style="width: 500px;"
          :disabled="type == 2"
        ></el-input>
      </el-form-item>
      <el-form-item label="封面">
        <img
          v-if="updataimg!=''"
          :src="updataimg"
          style="width: 80px;height: 80px;"
          alt=""
        >
        <el-upload
          ref="upload"
          class="upload-demo"
          action="#"
          :http-request="httpRequest"
          :multiple="true"
          :show-file-list="false"
          :limit="100"
        >
          <el-button
            size="small"
            type="primary"
            plain
          >点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="小程序名字">
        <el-input
          v-model="account_name"
          style="width: 500px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="简介">
        <el-input
          v-model="blurb"
          style="width: 500px;"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbit"
        >确定</el-button>
      </el-form-item>
    </el-form> -->
  </div>
</template>

<script>
import { getQcConfig } from '@/api/baiduAD.js'
import { addhtmlstr } from '@/api/customer.js'
import { uploadFilesimg } from '@/utils/ObjectStorage.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      app_id: '',
      account_name: '',
      updataimg: '',
      cover: '',
      type: null,
      id: '',
      domain: '',
      item: {},
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      blurb: '',

      config: {},

      backrColor: '#e8e2be', // 初始颜色为红色

      elements: [
        // {
        //   type: 'text',
        //   html: '<p style="color: green; font-size: 20px;">第一段内容</p>'
        // },
        // {
        //   type: 'image',
        //   html: '<img src="http://zyc-dev.jingxuanhz.com/dj/img/operation/newlyinmessage/operationPPIXD202409201726822829314.png" style="width: 100%; height: 100%; object-fit: unset;">'
        // },
        // {
        //   type: 'text',
        //   html: '<p style="color: green; font-size: 20px;">第二段内容</p>'
        // }
      ],
      currentEditIndex: null,
      fontColor: '#000000',
      fontSize: '26',
      textContent: '',
      imageUrl: '',
      buttonLabel: '',

      editLabel: '',
      editBackground: '#007bff',
      editColor: '#ffffff',
      editFontSize: 16,

      currentAlign: 'left', // 当前选中的对齐方式
      Passerbyvalue: '', // 获客链接
      landingpagename: '' // 落地页名称
    }
  },
  created() {},
  mounted() {
    // document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    // document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    send() {
      this.getconfig()
    },
    selectElement(index) {
      this.currentEditIndex = index
      const el = this.elements[index]
      if (el.type === 'text') {
        const colorMatch = el.html.match(/color:\s*([^;"]+)/)
        const sizeMatch = el.html.match(/font-size:\s*(\d+)px/)
        const textMatch = el.html.match(/>([^<]*)</)

        this.fontColor = colorMatch ? colorMatch[1] : '#000000'
        this.fontSize = sizeMatch ? sizeMatch[1] : '16'
        this.textContent = textMatch ? textMatch[1] : ''
        const alignMatch = el.html.match(/text-align:\s*(\w+);/)
        if (alignMatch) {
          this.currentAlign = alignMatch[1]
        } else {
          // 如果没有匹配到对齐样式，默认为 'left'
          this.currentAlign = 'left'
        }
      } else if (el.type === 'image') {
        const srcMatch = el.html.match(/src="([^"]+)"/)
        this.imageUrl = srcMatch ? srcMatch[1] : ''
      } else if (el.type === 'button') {
        const div = document.createElement('div')
        div.innerHTML = el.html
        // const button = div.firstChild
        const button = div.querySelector('.btn')
        console.log(button, 'button')
        this.editLabel = button.textContent || '按钮文字'
        this.editBackground = button.style.backgroundColor || '#007bff'
        this.editColor = button.style.color || '#ffffff'
        this.editFontSize = parseInt(button.style.fontSize || 16)
      } else if (el.type === 'xuanbutton') {
        const div = document.createElement('div')
        div.innerHTML = el.html
        const button = div.firstChild
        this.editLabel = button.textContent || '按钮文字'
        this.editBackground = button.style.backgroundColor || '#007bff'
        this.editColor = button.style.color || '#ffffff'
        this.editFontSize = parseInt(button.style.fontSize || 16)
      }
    },

    applyTextStyle() {
      const el = this.elements[this.currentEditIndex]
      const tag = el.html.match(/<(\w+)/)[1] || 'p'
      el.html = `<${tag} style="color: ${this.fontColor}; font-size: ${this.fontSize}px;padding: 0rem 0.38rem;white-space: pre-wrap;text-align: ${this.currentAlign};">${this.textContent}</${tag}>`
    },

    applyImage() {
      const el = this.elements[this.currentEditIndex]
      el.html = `<img src="${this.imageUrl}" style="width: 100%; height: 100%; object-fit: unset;">`
    },
    moveUp() {
      if (this.currentEditIndex > 0) {
        const idx = this.currentEditIndex
        const temp = this.elements[idx - 1]
        this.$set(this.elements, idx - 1, this.elements[idx])
        this.$set(this.elements, idx, temp)
        this.currentEditIndex = idx - 1 // 更新选中索引
      }
    },
    moveDown() {
      if (this.currentEditIndex < this.elements.length - 1) {
        const idx = this.currentEditIndex
        const temp = this.elements[idx + 1]
        this.$set(this.elements, idx + 1, this.elements[idx])
        this.$set(this.elements, idx, temp)
        this.currentEditIndex = idx + 1 // 更新选中索引
      }
    },
    clearSelection() {
      // 不选中 暂时不需要
      // this.currentEditIndex = null
    },
    async getconfig() {
      const res = await getQcConfig()
      this.config = res.data.qcconfig
    },
    async httpRequest(e) {
      // console.log('e:', e)
      const _this = this
      const fileIfon = e.file
      console.log('fileIfon:', fileIfon)
      const img = new Image()
      // const videoWidth = 0
      // const videoHeight = 0
      const fileType = fileIfon.type
      console.log('fileType:', fileType)

      if (fileType.startsWith('image/')) {
        // const temporary = e.files.length > 1 ? '多张' : window.URL.createObjectURL(fileIfon)
        // temporary !== '多张' && (img.src = temporary)
        // this.temporary = temporary
        const programimg = window.URL.createObjectURL(fileIfon)
        img.src = programimg
        const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
        const extension = ftype === '.jpg'
        const extension2 = ftype === '.png'
        const extension3 = ftype === '.jpeg'
        const extension4 = ftype === '.gif'
        // eslint-disable-next-line eqeqeq
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
            type: 'error'
          })
          return
        }
        console.log('fileIfon.size:', fileIfon.size)
        const maxSize = 20 * 1024 * 1024 // 设置最大文件大小为50MB
        if (fileIfon.size > maxSize) {
          return this.$message('上传图片太大')
        }
        _this.showProgress = true
        this.percentage = 0
        console.log('fileIfon:', fileIfon)
        await uploadFilesimg(
          fileIfon,
          (num, id) => {
            this.percentage = num
          },
          'operation',
          this.config
        )
          .then(res => {
            console.log('res-------:', res.files[0].options, this.config.domain)
            this.imageUrl = this.config.domain + res.files[0].options.Key
            _this.applyImage()
            // this.cover = res.files[0].options.Key
          })
          .catch(err => {
            console.log('err:-----', err)
          })
      } else {
        this.$message({
          message: '不支持的文件类型',
          type: 'error'
        })
      }
    },
    deltert() {
      this.elements.splice(this.currentEditIndex, 1)
      console.log('this.elements.length', this.elements.length)
      // this.currentEditIndex = this.elements.length - 1
      this.currentEditIndex = null
    },
    addtext() {},
    // addButtonDiv() {
    //   const label = '按钮文字'
    //   const bgColor = '#007bff'
    //   const fontColor = '#ffffff'
    //   const fontSize = 16

    //   const html = `<div style="background-color: ${bgColor}; color: ${fontColor}; font-size: ${fontSize}px;  border-radius: 4px; display: inline-block;width:100%;padding:10px 0px;text-align: center;">${label}</div>`

    //   this.elements.push({
    //     type: 'button',
    //     html
    //   })
    // },
    // 添加普通按钮
    addNormalButton() {
      const label = '按钮文字'
      const bgColor = '#007bff'
      const fontColor = '#ffffff'
      const fontSize = 26

      const html = `<div id="contactBtn" style="display: flex;justify-content: center;padding: 0rem 0.38rem;"><div class="btn" style="background-color: ${bgColor}; color: ${fontColor}; font-size: ${fontSize}px; border-radius: 4px; display: inline-block; width: 100%; padding: 0.3rem 0rem; text-align: center;">${label}</div></div>`

      this.elements.push({
        type: 'button',
        html
      })
    },

    // 添加悬浮按钮
    addFloatingButton() {
      const label = '底部悬浮按钮'
      const bgColor = '#28a745'
      const fontColor = '#ffffff'
      const fontSize = 16

      const html = `<div id="contactBtn" style="display: flex;justify-content: center;padding: 0rem 0.38rem;"><div class="btn" style="position: absolute; bottom: 0px; left: 50%; transform: translateX(-50%); background-color: ${bgColor}; color: ${fontColor}; font-size: ${fontSize}px; border-radius: 6px; padding: 0.3rem 0rem; cursor: pointer; z-index: 999;width:100%;text-align: center;">
      ${label}
    </div></div>`

      this.elements.push({
        type: 'xuanbutton',
        html
      })
    },
    applyButtonStyle() {
      const el = this.elements[this.currentEditIndex]
      if (el.type === 'button') {
        el.html = `<div id="contactBtn" style="display: flex;justify-content: center;padding: 0rem 0.38rem;;"><div class="btn" style="background-color: ${this.editBackground}; color: ${this.editColor}; font-size: ${this.editFontSize}px; border-radius: 4px; display: inline-block;width:100%;padding: 0.3rem 0rem;text-align: center;">${this.editLabel}</div></div>`
      } else {
        el.html = `<div id="contactBtn" style="display: flex;justify-content: center;padding: 0rem 0.38rem;;"><div class="btn" style="position: absolute; bottom: 0px; left: 50%; transform: translateX(-50%); background-color: ${this.editBackground}; color: ${this.editColor}; font-size: ${this.editFontSize}px; border-radius: 6px; padding: 0.3rem 0rem; cursor: pointer; z-index: 999;width:100%;text-align: center;">${this.editLabel}</div></div>`
      }
    },
    addImageDiv() {
      const defaultImage = 'https://zyc.jingxuanhz.com/dj/img/operation/newlyinmessage/operationIMKRX202504261745655198021.jpg' // 默认图片，可替换
      const html = `<img src="${defaultImage}" style="width: 100%; height: 100%; object-fit: unset;">`
      this.elements.push({
        type: 'image',
        html
      })
    },

    addParagraphText() {
      // const defaultText = '这里是一段纯文本'
      // const html = `<p style="color: ${this.fontColor}; font-size: ${this.fontSize}px;padding: 0rem 0.38rem;white-space: pre-wrap;text-align: ${this.currentAlign}">${defaultText}</p>`
      // this.elements.push({
      //   type: 'text',
      //   html
      // })
      const defaultText = '这里是一段纯文本'
      const newText = {
        type: 'text',
        html: `<p style="color: ${this.fontColor}; font-size: ${this.fontSize}px; text-align: ${this.currentAlign};padding: 0rem 0.38rem;white-space: pre-wrap;">${defaultText}</p>`
      }
      this.elements.push(newText)
    },
    sumbiter() {
      if (this.landingpagename === '') {
        this.$message.error('请输入落地页名称')
        return
      }
      if (this.elements.length === 0) {
        this.$message.error('请新增组件')
        return
      }
      if (this.Passerbyvalue === '') {
        this.$message.error('请输入获客链接')
        return
      }
      const htmlString = this.elements.map(el => el.html).join('')
      console.log(htmlString)
      // const script = `<scr` + `ipt>document.getElementById('contactBtn')?.addEventListener('click', function () {var wecomUrl = ${this.Passerbyvalue};window.location.href = wecomUrl;});</scr` + `ipt>`
      const script =
        `<scr` +
        `ipt>
        document.getElementById('contactBtn')?.addEventListener('click', function () { 
          const urlParams = new URLSearchParams(window.location.search);
          const impressId = urlParams.get('impress_id'); // 获取 impress_id 参数的值
          var wecomUrl = '${this.Passerbyvalue}?customer_channel=Iqiyi_' + impressId; // 将 impress_id 加入到 URL 中
          window.location.href = wecomUrl;
        });
      </scr` +
        `ipt>`
      const str = `<!DOCTYPE html><html lang="zh"><head><meta charset="UTF-8" name="viewport" content="width=device-width, initial-scale=1.0"><title>生成页面</title><style>html{font-size: 45px;padding: 0;
     margin: 0;}body {background-color: ${this.backrColor};font-family: "Helvetica", sans-serif;margin: 0;font-size: 45px}p {margin: 0}</style></head><body><div class="container">${htmlString}</div>${script}</body></html>`
      console.log(str)
      addhtmlstr({
        page_name: this.landingpagename,
        page_elements: str,
        jump_link: this.Passerbyvalue
      }).then(res => {
        this.$emit('updata')
        this.$message({
          message: '添加成功',
          type: 'success'
        })
      })
    },
    changeAlign(align) {
      if (this.currentEditIndex === null) return
      const el = this.elements[this.currentEditIndex]
      if (el.type !== 'text') return
      console.log('111')
      if (el.html.includes('text-align')) {
        console.log('222')
        el.html = el.html.replace(/text-align:\s*\w+;/, `text-align: ${align};color: ${this.fontColor}; font-size: ${this.fontSize}px;padding: 0rem 0.38rem;white-space: pre-wrap;`)
      } else {
        console.log('333')
        el.html = el.html.replace('<p ', `<p style="text-align: ${align};color: ${this.fontColor}; font-size: ${this.fontSize}px;padding: 0rem 0.38rem;white-space: pre-wrap;" `)
      }

      this.currentAlign = align
    }
    // handleOutsideClick(e) {
    //   // 如果点击的不是 editable-block 区域
    //   if (!e.target.closest('.editable-block')) {
    //     this.currentEditIndex = null
    //   }
    // }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.edit_box {
  display: flex;
  justify-content: space-between;
}
.left_box {
  width: 400px;
  /* background: pink; */
  padding: 10px;
  border: 1px solid #ccc;
}
.left_boxowe {
  width: 400px;
  /* background: pink; */
  text-align: center;
  line-height: 400px;
  border: 1px solid #ccc;
}
.left_boxoweduwe {
  text-align: center;
  line-height: 400px;
  border: 1px solid #ccc;
}
.edit-area {
  /* border: 1px solid #ccc; */
  /* padding: 10px; */
  margin-bottom: 20px;
  margin-left: 30px;
  width: 375px;
  max-height: 667px;
  overflow-y: auto;
}
.editable-block {
  padding: 6px 0px;
  margin: 5px 0;
  cursor: pointer;
  border: 1px dashed #aaa;
  transition: all 0.2s;
  position: relative;
}
.editable-block.selected {
  border: 2px solid #409eff; /* ElementUI主题蓝 */
  /* background-color: #f0f9ff; */
  box-shadow: 0 0 3px #409eff;
}

.align-button {
  border: 1px solid #ccc;
  padding: 8px 12px;
  margin-bottom: 8px;
  cursor: pointer;
  border-radius: 4px;
  width: 80px;
  text-align: center;
}
.align-button.active {
  background-color: #409eff;
  color: white;
  border-color: #409eff;
}
.imwa_vir {
  /* text-align: center; */
  margin-top: 10px;
}
.imwa_vix {
  border: 0.5px dashed #96b6f7;
  border-radius: 2px;
  width: 96px;
  height: 96px;
  /* padding: 10px; */
  text-align: center;
  line-height: 96px;
  cursor: pointer;
  margin-right: 20px;
}
.siopw_box {
  /* width: 300px; */
  flex-shrink: 0;
}
.wjaeeaw {
  display: flex;
  align-items: center;
}
.wjaeeawawe {
  display: flex;
}
.wjkwew {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
